import { graphql } from "../generated";

// Kept out of `GetShow` on purpose: `isBookmarked` is @authenticated, and the
// episode route loader runs `GetShow` before boot has registered the device
// user — see `useBookmark`.
export const GET_SHOW_BOOKMARK_STATE = graphql(`
  query GetShowBookmarkState($showId: ID!) {
    show(id: $showId) {
      id
      isBookmarked
    }
  }
`);
